import { FunctionComponent } from 'react'
import { useAppHandlers } from '../../../../../services/actions/app/useAppHandlers';
import { useBillingRequest } from '../../../../../services/apis/billing/useBillingRequest';
import CustomModal from "../../../CustomModal";
import { ICancelationFlowQuestions } from '../CancelFlow';
import styled from 'styled-components';
import posthog from 'posthog-js';
import moment from 'moment';
import { useAuthStore } from '../../../../../stores/auth/useAuthStore';
import { useBillingStore } from '../../../../../stores/billing/useBillingStore';
import { useAppStore } from '../../../../../stores/application/useAppStore';

interface IThanksForFeedbackSection {
    state?: ICancelationFlowQuestions
    nextSection: () => void
}

const ThanksForFeedbackSection: FunctionComponent<IThanksForFeedbackSection> = ({ nextSection, state }) => {
    const { hideModal } = useAppHandlers()
    const { deleteSubscriptionRequestHandler } = useBillingRequest()
    const { store: { subscription } } = useAuthStore();
    const { store: { selectedBillingPlan, selectedPrice, billingPlans } } = useBillingStore();
    const { store: { modal } } = useAppStore();

    const onConfirmHandler = async () => {
        const data = await deleteSubscriptionRequestHandler(state)
        if (data && data.cancelDate) {
            const currentPlanFromModal = modal?.props?.currentPlan;
            const matchedPlan = billingPlans?.find((plan: any) =>
                plan?.prices?.some((price: any) =>
                    price?.productId === subscription?.productId || price?.priceId === subscription?.priceId
                )
            );
            const planName = selectedBillingPlan?.name ?? matchedPlan?.name;
            const interval = selectedPrice?.interval ?? subscription?.interval;
            const currentPlan = currentPlanFromModal
                ? String(currentPlanFromModal)
                : (planName && interval
                ? `${planName} ${interval === 'year' ? 'Yearly' : 'Monthly'}`
                : (planName || 'Unknown'));
            const createdAt = (subscription as any)?.createdAt;
            const modalTenureDays = Number(modal?.props?.tenureDays);
            const tenureDays = Number.isFinite(modalTenureDays) && modalTenureDays >= 0
                ? modalTenureDays
                : (createdAt && moment(createdAt).isValid()
                    ? Math.max(0, moment().diff(moment(createdAt), 'days'))
                    : 0);

            posthog.capture('cancellation flow confirmed', {
                current_plan: currentPlan,
                tenure_days: tenureDays,
                reason_selected: state?.code || 'not_selected',
            });

            nextSection()
        }
    }

    return (
        <CustomModal
            headingText={'Thanks for the feedback! Here’s what happens next.'}
            descriptionText={<StyledText>{'Once your billing period expires you will lose access to your LeadDelta account and all its data: tags, notes, etc.'}</StyledText>}
            closeButton
            cancelButton={{
                text: 'I changed my mind',
                bigButton: true,
                onClickHandler: hideModal
            }}
            confirmButton={{
                text: 'Cancel subscription',
                bigButton: true,
                onClickHandler: onConfirmHandler
            }}
        >
        </CustomModal>
    )

}
const StyledText = styled.div`
    display: inline-block;
    text-align: left;
    font-weight: normal;
`


export default ThanksForFeedbackSection